export enum TypeSearch {
    searches = 'searches',
    localizations = 'localizations',
    menu = 'menu'
}
